import React, {useEffect, useState} from 'react';
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Paper from "@material-ui/core/Paper";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import api from '../../services/api'
import Select from "react-select";
import Typography from "@material-ui/core/Typography";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import DeleteIcon from '@material-ui/icons/Delete';
import TableBody from "@material-ui/core/TableBody";
import Swal from "sweetalert2";
import {useHistory} from "react-router-dom"



const useStyles = makeStyles((theme) => ({
    root:{
        minWidth: "75vw",
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    table: {
        //minWidth: "35vw",
    },
    table2: {
        maxWidth: "35vw",
    },
    select: {
        minWidth: "35vw",
    }
}));

export default function DocumentosEditar(props){
    const classes = useStyles();
    const [artigos, setArtigos] = useState([]);
    const [tara, setTara] = useState({value:1, label:"Vendida"});
    const [infoArtigo, setInfoArtigo] = useState({
        preco: Number().toFixed(2),
        id: "",
        itemCode: "",
        descricao: "",
        unidade: "",
        estado: "",
        idFamilia: "",
        familia:"",
        quantidade:Number().toFixed(2),
    });
    const [artigo, setArtigo] = useState([]);
    const [totalDoc, setTotalDoc] = useState(0.00);
    const [pagamento, setPagamento] = useState(false);
    const [anular, setAnular] = useState(false);
    const [edit, setEdit] = useState(false);
    const [confirmado, setConfirmado] = useState(false);

    const history = useHistory();
    const [documento, setDocumento] = useState({
        cc:Number(),
        cliente: "",
        informacoes: [],
        linhas: [],
        pagamentos: [],
        informacoesCliente:[{
            linhaPrecos:1
        }]
    });

    useEffect(()=>{
        api.get('/documentos/'+props.match.params.id).then(res=>{
            if(res.data.code===0){
                setDocumento(res.data.data);
                let temp = 0;
                for (let row of res.data.data.linhas){
                    temp += row.totalLinha

                }
                console.log(res.data.data)
                setTotalDoc(temp)
            }
        })
        api.get('/item').then(res=>{
            if(res.data.code===0){
                setArtigos(res.data.data)
            }
        })
    },[props.match.params.id]);

    function defenirLinhas() {
        const temp = documento;
        let total=0.00;
        temp.linhas.push({
            ...infoArtigo,
            quantidade:Number(infoArtigo.quantidade).toFixed(parseInt(infoArtigo.MaximumDecimals)),
            tara: infoArtigo.tara,
            tipo:tara.value,
        });
        for (let row of temp.linhas) {
            if(!isNaN(parseFloat(row.preco))) {
                total += calculatePrice(parseFloat(row.quantidade) , parseFloat(row.preco), row.desconto)
            }else{
                total+=0
            }
        }

        setTotalDoc(total);
        setInfoArtigo({
            preco: Number().toFixed(2),
            id: "",
            itemCode: "",
            descricao: "",
            unidade: "",
            estado: "",
            idFamilia: "",
            familia:"",
            desconto:"",
            precos:[0,0,0],
            Description: "",
            MaximumDecimals: "0",
            UnitOfMeasureID: "",
            quantidade:Number().toFixed(parseInt('0')),
        })
        setArtigo({})

        setDocumento(temp)
    }
    function defineArtigo(data) {
        data.preco=data.precos[documento.informacoesCliente[0].linhaPrecos-1]
        setArtigo(data)
        data.quantidade = 0;
        let set = false
        const sistemaDesconto = JSON.parse(data.sistemaDesconto)
        for(let row of sistemaDesconto){
            if(row.linhaPreco==documento.informacoesCliente[0].linhaPrecos){
                data.desconto=row.desconto
                set = true
            }
        }
        if(set==false)
            data.desconto=0
        setInfoArtigo(data);
        setTara({value:1, label:"Vendida"});
    }

    function definePreco(e) {
        if(e.target.value>=0) {
            setInfoArtigo({
                ...infoArtigo,
                preco: e.target.value,
            })
        }
    }

    function defineQuantidade(e) {
        if(e.target.value>=0){
            setInfoArtigo({
                ...infoArtigo,
                quantidade:e.target.value,


            })
        }
    }

    function defineDesconto(e) {
        if(!isNaN(Number(e.target.value))){
            if(Number(e.target.value)>=0 && Number(e.target.value)<=100) {
                setInfoArtigo({
                    ...infoArtigo,
                    desconto:e.target.value
                })
            }
        }
    }

    function guardarDoc() {
        let data=documento;
        data.confirmado=confirmado===true?2:1;
        api.put('/documentos/'+props.match.params.id, data).then(async res=>{
            setPagamento(false)
            await Swal.fire({
                title: "Informação",
                text: res.data.message,
                icon: res.data.code === 0 ? "success" : "error",
                timer: 3000
            })
            if(res.data.code === 0) {
                history.push("/documentos/ver/"+props.match.params.id)
            }
        })
    }

    function anularDoc(){
        api.delete('/documentos/'+props.match.params.id).then(async res=>{
            setAnular(false)
            await Swal.fire({
                title: "Informação",
                text: res.data.message,
                icon: res.data.code === 0 ? "success" : "error",
                timer: 3000
            })
            if(res.data.code === 0) {
                history.push("/documentos/ver/"+props.match.params.id)
            }
    })
    }

    function editarLinha(idx) {
        // eslint-disable-next-line array-callback-return
        const newTmp=documento.linhas.filter((value, index) => {
            if(index===idx){
                setInfoArtigo(value);
                const listaTara=[{value:1, label:"Vendida"},{value:2, label:"Emprestada"},{value:3, label:"Oferta"} ];
                if(value.tipo!==undefined){
                    setTara(listaTara[value.tipo-1])
                }else{
                    setTara(listaTara[0])
                }
            }else{
                return value;
            }
        })
        let total=0.00;
        for(let row of newTmp){
            total+=calculatePrice(parseFloat(row.quantidade) , parseFloat(row.preco), row.desconto)
        }
        setTotalDoc(total)
        let temp = documento
        temp.linhas = newTmp
        setDocumento(temp);
    }

    function removerLinha(idx) {
        // eslint-disable-next-line array-callback-return
        const newTmp=documento.linhas.filter((value, index) => {
            if (index !== idx) {
                return value;
            }
        })
        let total=0.00;
        for(let row of newTmp){
            total+=calculatePrice(parseFloat(row.quantidade) , parseFloat(row.preco), row.desconto)
        }
        setTotalDoc(total)
        let temp = documento
        temp.linhas = newTmp
        setDocumento(temp);

    }

    function calculatePrice(quantidade, preco, desconto=0){
        const precoFinal = parseFloat(quantidade)*parseFloat(preco);
        return precoFinal - (precoFinal*(parseFloat(desconto)/100))
    }

    return(
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    Editar registo <br/>
                </Typography>
                <Card className={classes.root} variant="outlined">
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Select
                                    onChange={defineArtigo}
                                    name="artigos"
                                    option={artigo}
                                    placeholder="Artigos"
                                    options={artigos}
                                    getOptionLabel={(option)=> option.artigo}
                                    getOptionValue ={(option)=>option.id}
                                />
                            </Grid>


                            <Grid item xs={12} sm={6}>
                                <Grid item xs={6} sm={4}>
                                    Confirmado: <Switch onChange={()=>setConfirmado(!confirmado)} checked={confirmado} color={"primary"}/>
                                </Grid>
                                Linha de precos em uso: {documento.informacoesCliente[0].linhaPrecos} <br/>

                                <TableContainer component={Paper} style={{marginBottom: 10, marginTop: 20}}>
                                    <Table className={classes.table} aria-label="Descricao do artigo">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Codigo artigo</TableCell>
                                                <TableCell>Preço</TableCell>
                                                <TableCell>Desconto</TableCell>
                                                <TableCell>Unidade</TableCell>
                                                <TableCell>Quantidade</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow >
                                                <TableCell>{infoArtigo.itemCode}</TableCell>
                                                <TableCell><TextField name="preco" disabled={tara.value!==1} onChange={definePreco} type="number" value={infoArtigo.preco}/></TableCell>
                                                <TableCell><TextField name="desconto" onChange={defineDesconto} type="number" value={infoArtigo.desconto}/></TableCell>
                                                <TableCell>{infoArtigo.UnitOfMeasureID}</TableCell>
                                                <TableCell><TextField name="quantidade" onChange={defineQuantidade} type="number"  value={infoArtigo.quantidade}/></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Button onClick={defenirLinhas} disabled={infoArtigo.idFamilia === "" || parseFloat(infoArtigo.quantidade) <= 0} fullWidth style={{marginTop: 20}} variant="contained" color="primary">Adicionar artigo</Button>
                            </Grid>
                            <Grid item xs={12}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} aria-label="Artigos do documento">
                                            <TableHead>
                                                <TableRow>
                                                    {edit===false?(<TableCell>Codigo artigo</TableCell>):(null)}
                                                    <TableCell>Descrição</TableCell>
                                                    <TableCell>Desconto</TableCell>
                                                    <TableCell >Preço</TableCell>
                                                    {edit===false?(<TableCell>Quantidade</TableCell>):(<TableCell colSpan={2}><center>Ações</center></TableCell>)}
                                                    {edit===false?(<TableCell>Preço da linha</TableCell>):(null)}
                                                </TableRow>
                                            </TableHead>
                                        <TableBody>
                                            {documento.linhas.map((row, index) =>
                                                <TableRow key={index}>
                                                    {edit===false?(<TableCell>{row.itemCode}</TableCell>):null}
                                                    <TableCell>{row.descricao}</TableCell>
                                                    <TableCell>{parseFloat(row.desconto).toFixed(2)}</TableCell>
                                                    <TableCell>{isNaN(parseFloat(row.preco))?"0.00":parseFloat(row.preco).toFixed(2)}€/{row.UnitOfMeasureID}</TableCell>
                                                    {edit===false?(<TableCell>{Number(row.quantidade).toFixed(row.MaximumDecimals)}</TableCell>):(<TableCell><Button onClick={()=>editarLinha(index)} variant="contained" color="primary">Editar linha</Button></TableCell>)}
                                                    {edit===false?(<TableCell>{isNaN(parseFloat(row.quantidade) * parseFloat(row.preco))?"0.00":calculatePrice(parseFloat(row.quantidade), parseFloat(row.preco), row.desconto).toFixed(2)}€</TableCell>):(<TableCell><Button variant="contained" className={classes.button} startIcon={<DeleteIcon />} onClick={() =>removerLinha(index)}>Remover linha</Button></TableCell>)}
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Button onClick={()=>setPagamento(true)} disabled={documento.linhas.length<= 0 } fullWidth style={{marginTop: 20}} variant="contained" color="primary">Guardar encomenda total: {totalDoc.toFixed(2)}€</Button>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={edit}
                                            onChange={()=>setEdit(!edit)}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label="Editar documento"
                                />
                                <Button onClick={()=>setAnular(true)} style={{margin: 20, float:"right"}} variant={"outlined"} color={"primary"}>Anular documento</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
            <Dialog
                open={pagamento}
                onClose={()=>setPagamento(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">{"Guardar documento?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        O documento dá no total {totalDoc.toFixed(2)}€ deseja colocar em conta corrente ou pagar agora?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setPagamento(false)} color="primary">
                        Cancelar ação
                    </Button>
                    <Button onClick={()=>guardarDoc()} color="primary" autoFocus>
                        Guardar alterações
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={anular}
                onClose={()=>setAnular(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">{"Anular documento?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tem a certeza que pertende anular o documento?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setAnular(false)} color="primary">
                        Não
                    </Button>
                    <Button onClick={()=>anularDoc()} color="primary" >
                        Sim
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}
